import moment from 'moment'

import countries from 'i18n-iso-countries'

export function getCountryName(countryCode) {
  let code = countries.getName(countryCode, "en", {select: "official"});
  if (!code) {
    code = ""
  }
  return code
}

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
}

export function makeRelativeTimeString(timestamp, capitalize) {
  let str = moment(timestamp).fromNow(false);

  if (capitalize) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str
}
